import { render, staticRenderFns } from "./HelpdeskNavigationDrawer.vue?vue&type=template&id=17fc7ae0"
import script from "./HelpdeskNavigationDrawer.vue?vue&type=script&lang=js"
export * from "./HelpdeskNavigationDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports